export default {
    blogs(state) {
        return state.blogs
    },
    getBlog: (state) => (id) => {
        return state.blogs.find(
            (blog) => blog.id == id
        )
    },
}